import { render } from "./Create.vue?vue&type=template&id=5ccba268&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=5ccba268&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ccba268"

export default script